export const Loader = () => {
    return <>
        <div className="loading_box">
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <span className="spin_text">Hang in there while we process your request!</span>
        </div>
    </>
}